import { addDoc, collection } from "@firebase/firestore"
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from "../../../shared/snackbar/snackbar-slice";
import { hideLoading, showLoading } from "./bids-add-slice";
import { addBid } from "../bid-list/bids-list-slice";
import { getDownloadURL, uploadBytesResumable } from "firebase/storage";

const uploadPhoto = async (dispatch, storageRef, file) => {
    try {
        const uploadTask = uploadBytesResumable(storageRef, file);
        const snapshot = await uploadTask;
        const downloadURL = await getDownloadURL(snapshot.ref);
        dispatch(showSuccessSnackbar("Photo uploaded successfully!"));
        return downloadURL;
    } catch(e) {
        dispatch(showErrorSnackbar('Something went wrong when uploading the photo.'));
        console.error("ItemPhotosAdd uploadPhoto error: ", e);
    }
};

export const addBidService = async (dispatch, db, coll, formData, storageRef, file) => {
    dispatch(showLoading());
    try {
        if (file) {
            const uploadURL = await uploadPhoto(dispatch, storageRef, file);
            const newFormData = {
                ...formData,
                image_url: uploadURL,
            };
            const docRef = await addDoc(collection(db, coll), newFormData);
            dispatch(addBid({
                id: docRef.id,
                ...newFormData
            }));
            dispatch(showSuccessSnackbar('Added successfully!'));
        } else {
            dispatch(showWarningSnackbar("File does not exist."));
        }
    } catch(e) {
        dispatch(showErrorSnackbar('Add failed! Please try again.'));
        console.error("BidAdd addBidService error: ", e);
    }
    dispatch(hideLoading());
};